// extracted by mini-css-extract-plugin
export default {"item":"FriendList_item__c-6on","statusOffline":"FriendList_statusOffline__Jpw7r","statusOnline":"FriendList_statusOnline__i4cxN","name":"FriendList_name__3Gr10"};